import React, { useMemo, useContext } from 'react'
import omit from 'lodash/omit'
import { SchemaContext } from '@/libs/components/SchemaRendererForm/common/util'
import { FIELD_FILTER_LIST } from '@/libs/components/SchemaRendererForm/common/enum'
import renderers from './renderers'
import { SchemaNode, CustomComponents } from './index.d'

/** 自定义组件示例
 *  1. customComponents={{ '组件name': (schemaNode, contextDataCollection) => InputField}}
 *  2. customComponents={{ '组件name': (schemaNode, contextDataCollection) => () => (<InputField />)}}
 */

export type SchemaRendererProps = {
  schemaNode: SchemaNode
  customComponents?: CustomComponents
}

const Index = (props: SchemaRendererProps) => {
  // 获取上层传入的contextDataCollection
  const contextDataCollection = useContext(SchemaContext)
  const { schemaNode, customComponents } = props
  // 根据schemaNode.type获取当前渲染的renderer
  const renderer = renderers[schemaNode.type]
  // 根据schemaNode.type获取当前渲染的customComponent
  const customComponent = customComponents?.[schemaNode.type]

  if (!renderer && !customComponent) {
    throw new Error(`找不到渲染类型为${schemaNode.type}的模板!!!`)
  }

  // 获取最终渲染的组件
  const Component = customComponent?.(schemaNode, contextDataCollection) || renderer

  return useMemo(
    () => (
      <Component
        {...omit(schemaNode.attributes, FIELD_FILTER_LIST)}
        {...omit(props, FIELD_FILTER_LIST)}
        contextDataCollection={contextDataCollection}
      />
    ),
    [props],
  )
}

export default Index
